var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDrag = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 27,
    viewBox: "0 0 17 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.76923 7.31849C5.29863 7.31849 6.53846 6.07866 6.53846 4.54926C6.53846 3.01986 5.29863 1.78003 3.76923 1.78003C2.23983 1.78003 1 3.01986 1 4.54926C1 6.07866 2.23983 7.31849 3.76923 7.31849Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.76923 16.5492C5.29863 16.5492 6.53846 15.3094 6.53846 13.78C6.53846 12.2506 5.29863 11.0107 3.76923 11.0107C2.23983 11.0107 1 12.2506 1 13.78C1 15.3094 2.23983 16.5492 3.76923 16.5492Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13 7.31849C14.5294 7.31849 15.7692 6.07866 15.7692 4.54926C15.7692 3.01986 14.5294 1.78003 13 1.78003C11.4706 1.78003 10.2308 3.01986 10.2308 4.54926C10.2308 6.07866 11.4706 7.31849 13 7.31849Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13 16.5492C14.5294 16.5492 15.7692 15.3094 15.7692 13.78C15.7692 12.2506 14.5294 11.0107 13 11.0107C11.4706 11.0107 10.2308 12.2506 10.2308 13.78C10.2308 15.3094 11.4706 16.5492 13 16.5492Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13 25.78C14.5294 25.78 15.7692 24.5402 15.7692 23.0108C15.7692 21.4814 14.5294 20.2416 13 20.2416C11.4706 20.2416 10.2308 21.4814 10.2308 23.0108C10.2308 24.5402 11.4706 25.78 13 25.78Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.76923 25.78C5.29863 25.78 6.53846 24.5402 6.53846 23.0108C6.53846 21.4814 5.29863 20.2416 3.76923 20.2416C2.23983 20.2416 1 21.4814 1 23.0108C1 24.5402 2.23983 25.78 3.76923 25.78Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDrag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/drag.528f462b.svg";
export { ForwardRef as ReactComponent };